import { Reducer } from 'redux'
import { DetailPageActions, DetailPageActionTypes } from '../actions'

// Thresholds for EpisodeList
export const FIRST_EXPANDER_THRESHOLD = 4
export const SECOND_EXPANDER_THRESHOLD = 25

export interface CollectionDetail {
  header?: string
  collectionType?: string
  totalCardSize?: number
  titleIds: string[]
}

export type TitleIdToCollections = {
  [titleId: string]: CollectionDetail[] | undefined
}

export type TypeToCollection = {
  [collectionType: string]: CollectionDetail | undefined
}

const initialValue = {} as TitleIdToCollections

export const COLLECTION_LIST = ['episodes', 'bonus']

//TODO(AVWebDP-344) Simplify once CollectionDetail[] is changed to ([type: string]: CollectionDetail)
const mergeToCollectionMap = (typeToCollection: TypeToCollection, collections: CollectionDetail[]) => {
  collections.reduce((acc, col) => {
    if (col.collectionType) {
      // If collection already exists then merge titleIds
      if (acc[col.collectionType]) {
        acc[col.collectionType].titleIds =
          Array.from(new Set([...acc[col.collectionType].titleIds, ...col.titleIds]))
      } else {
        acc[col.collectionType] = {...col} as CollectionDetail
      }
    }
    return acc
  }, typeToCollection || {})
}

const mergeCollections = (state: TitleIdToCollections, nextState: TitleIdToCollections) : TitleIdToCollections => {
  const res = Object.keys(state).reduce((acc, titleId) => {
    acc[titleId] = [...state[titleId]] as CollectionDetail[]
    return acc
  }, {} as TitleIdToCollections)

  return Object.keys(nextState).reduce((acc, titleId) => {
    if (!acc[titleId]) {
      acc[titleId] = [...nextState[titleId]] as CollectionDetail[]
    } else {
      // Need to merge Collection Detail arrays so that titleIds is not overwritten
      const typeToCollection = {} as TypeToCollection
      mergeToCollectionMap(typeToCollection, acc[titleId])
      mergeToCollectionMap(typeToCollection, nextState[titleId])

      // The collection type must be in the store (undefined Collection causes fatal)
      const types = new Set(Object.keys(typeToCollection))
      acc[titleId] = COLLECTION_LIST
        .filter((colType) => types.has(colType))
        .map((colType) => typeToCollection[colType])
    }
    return acc
  }, res)
}

export const reducer =
  ((state: TitleIdToCollections = initialValue, action: DetailPageActions) => {
    switch (action.type) {
      case DetailPageActionTypes.STORE_MERGE:
        return action.payload.collections ? mergeCollections(state, action.payload.collections) : state
      case DetailPageActionTypes.CHANGE_PAGE:
        return mergeCollections({}, action.payload.collections)
      default:
        return state
    }
  }) as Reducer<TitleIdToCollections, DetailPageActions>
